/**
 * BeHuman's fixed reason codes for a `review` decision (see `inquiry-decision.ts`), in the order
 * they are checked — the first that applies is recorded. A `.schema.ts` file so the staff identity
 * contract can import it without pulling the decision logic into frontend bundles.
 */
export const DECISION_REASONS = [
  /** Persona failed, expired or declined the inquiry. */
  'persona_negative',
  /** The government-ID verification did not pass. */
  'id_not_passed',
  'id_expired',
  /** No readable expiration date on the ID, so "not expired" cannot be shown. */
  'id_expiry_unknown',
  /** The selfie (face match and liveness) did not pass. */
  'selfie_not_passed',
  /** The ID or the chart lacks a name or birth date to compare. */
  'demographics_unavailable',
  'name_mismatch',
  'dob_mismatch',
] as const

export type DecisionReason = (typeof DECISION_REASONS)[number]
